module.exports = __webpack_public_path__ + "static/media/supabase-logo.8e6477a7.png";